import { render, staticRenderFns } from "./Truncate.vue?vue&type=template&id=e1273200&scoped=true&"
import script from "./Truncate.vue?vue&type=script&lang=ts&"
export * from "./Truncate.vue?vue&type=script&lang=ts&"
import style0 from "./Truncate.vue?vue&type=style&index=0&id=e1273200&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1273200",
  null
  
)

export default component.exports